import React from "react";
import "../styles/Gallery.css"; // Ensure this file exists

const images = [
  "/images/placeholder.png",
  "/images/barbie-fullface-ring.webp",
  "/images/babyshower-golden-flex.webp",
  "/images/barbie-theme-balloon-decoration-book-barbie-doll-theme-party-decor-decorzoom.webp",
  "/images/beautifull-decoration-balloon-curtains-circle.webp",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/cocomelon-birthday-stage-setup.webp",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png",
  "/images/placeholder.png"
];

const Gallery = () => {
  return (
    <div className="overflow-hidden whitespace-nowrap w-full py-6 bg-white shadow-inner">
      <div className="inline-block animate-marquee space-x-4">
        {/* Pehla set images ka */}
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Gallery ${index + 1}`}
            className="inline-block w-48 h-48 object-cover rounded-full shadow-md border-2 border-white md:w-64 lg:w-80"
            onError={(e) => { e.target.src = "/images/Activities.webp"; }}
          />
        ))}
        {/* Doosra set images ka taaki loop seamless chale */}
        {images.map((src, index) => (
          <img
            key={`dup-${index}`}
            src={src}
            alt={`Gallery Duplicate ${index + 1}`}
            className="inline-block w-48 h-48 object-cover rounded-full shadow-md border-2 border-white md:w-64 lg:w-80"
            onError={(e) => { e.target.src = "/images/Activities.webp"; }}
          />
        ))}
      </div>
    </div>
  );
};

export default Gallery;
